const apiHost = {
  dev: 'http://localhost:4000',
  production: 'https://api.privateguidechiangmai.com'
}

export default apiHost.production
